module.exports = __webpack_public_path__ + "img/linux-adv-02-preview.fc1b104f.jpg";